import { render } from "./CardComponent.vue?vue&type=template&id=825d69ba&scoped=true&ts=true"
import script from "./CardComponent.vue?vue&type=script&lang=ts"
export * from "./CardComponent.vue?vue&type=script&lang=ts"

import "./CardComponent.vue?vue&type=style&index=0&id=825d69ba&scoped=true&lang=scss"

import exportComponent from "/Users/sylvainleris/Documents/workspace/ADETEC/AdConnect/fr.adetec.adconnect.www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-825d69ba"]])

export default __exports__